import React from 'react'
import AnimatedSection from '../elements/animated-section'
import AnimatedElement from '../elements/animated-element'

const Section = ({ name, styling, children, content: Content }) => {
  const styles = {
    section: styling && styling.section ? styling.section : 'relative',
    content: styling && styling.content ? styling.content : 'relative'
  }

  const sectionAnimationOptions = styling && styling.sectionAnimation ? styling.sectionAnimation : null
  const contentAnimationOptions = styling && styling.contentAnimation ? styling.contentAnimation : null

  return (
    <AnimatedSection
      options={sectionAnimationOptions}
      className={`${name}-section ${styles.section}`}
    >
      <Content />
      <AnimatedElement
        options={contentAnimationOptions}
        className={`${name}-content ${styles.content}`}
      >
        {children}
      </AnimatedElement>
    </AnimatedSection>
  )
}

export default Section
